import { Component, OnInit } from '@angular/core';
import { ButtonsPopupService } from 'src/app/shared/components/buttons-popup/service/buttons-popup.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CompanyConfigurationService } from '../service/company-configuration.service';
import { SnackbarService } from 'src/app/shared/components/snackbar/service/snackbar.service';

@Component({
  selector: 'app-company-configuration',
  templateUrl: './company-configuration.component.html',
  styleUrls: ['./company-configuration.component.scss']
})

export class CompanyConfigurationComponent implements OnInit {
  companyInfo: any = {
    company_id: '',
    market_type: {
      sale: true,
      rent: true,
      product_management: {
        company: true,
        director_company: false,
        leader_company: false,
        user: {}
      },
      primary_market: true,
      secondary_market: true
    },
    unattended_lead_alert: [],
    new_lead_alert: []
  };
  public readonly returnInList = ['Minuto', 'Hora', 'Dia', 'Semana'];
  loading = true;
  currentLead;
  showUserModal = false;
  marketDropdown = false;
  disqualificationList = [
    {
      label: 'Empresa',
      func: () => {
        this.resetMarketTypeProduct();
        this.companyInfo.market_type.product_management.company = true;
      }
    },
    {
      label: 'Diretor da empresa',
      func: () => {
        this.resetMarketTypeProduct();
        this.companyInfo.market_type.product_management.director_company = true;
      }
    },
    {
      label: 'Líder imediato',
      func: () => {
        this.resetMarketTypeProduct();
        this.companyInfo.market_type.product_management.leader_company = true;
      }
    },
    {
      label: 'Outro usuário',
      func: () => {
        this.showUserModal = true;
        this.modalFunc = (user) => {
          this.resetMarketTypeProduct();
          this.companyInfo.market_type.product_management.user = user;
        };
      }
    }
  ];

  errorModalUnattendedAlertTime = {
    title: 'Atenção',
    description: 'Selecione um tempo do alerta para leads não atendidos',
    buttons: [{
      btnType: 0,
      title: 'Ok',
      func: () => null,
    }]
  };

  errorModalUnattendedLeads = {
    title: 'Atenção',
    description: 'Selecione quem recebe os alertas de leads não atendidos',
    buttons: [{
      btnType: 0,
      title: 'Ok',
      func: () => null,
    }]
  };

  errorModalBtns = {
    title: 'Atenção',
    description: 'Selecione pelo menos um tipo de mercado',
    buttons: [{
      btnType: 0,
      title: 'Ok',
      func: () => null,
    }]
  };

  errorModalMarket = {
    title: 'Atenção',
    description: 'Selecione venda ou locação',
    buttons: [{
      btnType: 0,
      title: 'Ok',
      func: () => null,
    }]
  };

  modalFunc = (user) => {};

  get newLeadDeafult() {
    return {
      destinataries: [
        {
          type: 'OWN_USER',
        }
      ],
      own_user: true,
      initial_time: '00:00',
      final_time: '23:59'
    };
  }

  get unattendedLeadDeafult() {
    return {
      destinataries: [
        {
          type: 'OWN_USER',
        },
        {
          type: 'IMMEDIATE_LEADER',
        }
      ],
      own_user: true,
      leader_user: true,
      initial_time: '08:00',
      final_time: '20:00',
      time_type: 'Minuto',
      time_alert_value: 30
    };
  }

  constructor(
    private btnsService: ButtonsPopupService,
    private router: Router,
    private companyService: CompanyConfigurationService,
    private activatedRoute: ActivatedRoute,
    private snackbarService: SnackbarService
  ) { }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      this.companyInfo.company_id = params.id;

      this.companyService.getCompanyConfig(params.id).subscribe(resp => {
        this.companyInfo = resp;
        this.formatList();
        this.loading = false;
      }, () => {
        this.formatList();
        this.loading = false;
      });
    });
  }

  formatList() {
    if (this.companyInfo.new_lead_alert.length === 0) {
      this.companyInfo.new_lead_alert.push(this.newLeadDeafult);
    } else {
      this.companyInfo.new_lead_alert.forEach(newLead => {
        newLead.own_user = false;
        newLead.leader_user = false;
        newLead.destinataries.forEach(dest => {
          switch (dest.type) {
            case 'OWN_USER':
              newLead.own_user = true;
              break;
            case 'IMMEDIATE_LEADER':
              newLead.leader_user = true;
              break;
          }
        });
      });
    }

    if (this.companyInfo.unattended_lead_alert.length === 0) {
      this.companyInfo.unattended_lead_alert.push(this.unattendedLeadDeafult);
    } else {
      this.companyInfo.unattended_lead_alert.forEach(unattendedLead => {
        unattendedLead.own_user = false;
        unattendedLead.leader_user = false;
        unattendedLead.time_type = this.formatAlertTime(unattendedLead.time_type);
        unattendedLead.destinataries.forEach(dest => {
          switch (dest.type) {
            case 'OWN_USER':
              unattendedLead.own_user = true;
              break;
            case 'IMMEDIATE_LEADER':
              unattendedLead.leader_user = true;
              break;
          }
        });
      });
    }
  }

  formatAlertTime(value: string): string {
    switch (value) {
      case 'MINUTES':
        return 'Minuto';
      case 'HOURS':
        return 'Hora';
      case 'DAYS':
        return 'Dia';
      case 'WEEKS ':
        return 'Semana';

      case 'Minuto':
        return 'MINUTES';
      case 'Hora':
        return 'HOURS';
      case 'Dia':
        return 'DAYS';
      case 'Semana ':
        return 'WEEKS';
    }
  }

  getMarketProdutName(): string {
    if (this.companyInfo.market_type.product_management.company) {
      return 'Empresa';
    } else if (this.companyInfo.market_type.product_management.director_company) {
      return 'Diretor da empresa';
    } else if (this.companyInfo.market_type.product_management.leader_company) {
      return 'Líder imediato';
    } else if (this.companyInfo.market_type.product_management.user) {
      return this.companyInfo.market_type.product_management.user.name;
    }
  }

  formatReturnIn(value: {name: string, value: string}): string {
    if (value.value && value.name) {
      return `${value.value} ${value.name}${parseInt(value.value, 10) > 1 ? 's' : ''}`;
    } else {
      return null;
    }
  }

  removeTags(value: {tag: string, index: number}, lead) {
    if (!lead.destinataries[value.index]) {
      return;
    }

    switch (lead.destinataries[value.index].type) {
      case 'OWN_USER':
        lead.own_user = false;
        break;
      case 'IMMEDIATE_LEADER':
        lead.leader_user = false;
        break;
    }

    lead.destinataries.splice(value.index, 1);
  }

  selectCheckbox(form, state, type: string) {
    if (state === false) {
      form.destinataries = form.destinataries.filter(item => item.type !== type);
    } else {
      form.destinataries.push({
        type
      });
    }
  }

  getTags(lead) {
    const resp = [];

    lead.forEach(item => {
      switch (item.type) {
        case 'OWN_USER':
          resp.push('Próprio usuário');
          break;
        case 'IMMEDIATE_LEADER':
          resp.push('Líder imediato');
          break;
        case 'ANOTHER_USER':
          resp.push(item.user.name);
          break;
      }
    });

    return resp;
  }

  findUser(form, isInattendedLead = false) {
    this.modalFunc = (user) => {
      if (!isInattendedLead) {
        form.destinataries = form.destinataries.filter(item => item.type !== 'ANOTHER_USER');
      } else {
        for (const item of form.destinataries) {
          if (item.user) {
            if (item.user.id === user.id) {
              console.log('igual');
              return;
            }
          }
        }

        form.destinataries.push(
          {
            type: 'ANOTHER_USER',
            user
          });
      }
    };
    this.showUserModal = true;
  }

  selectUser(user) {
    this.modalFunc(user);
    this.showUserModal = false;
  }

  addNewLead() {
    this.companyInfo.new_lead_alert.push(this.newLeadDeafult);
  }

  removeNewLead(index: number) {
    this.companyInfo.new_lead_alert.splice(index, 1);
  }

  addNewLeadNotMet() {
    this.companyInfo.unattended_lead_alert.push(this.unattendedLeadDeafult);
  }

  removeNewLeadNotMet(index: number) {
    this.companyInfo.unattended_lead_alert.splice(index, 1);
  }

  resetMarketTypeProduct() {
    this.companyInfo.market_type.product_management.company = false;
    this.companyInfo.market_type.product_management.director_company = false;
    this.companyInfo.market_type.product_management.leader_company = false;
    this.companyInfo.market_type.product_management.user = null;
  }

  changeSecondaryMarket(ev) {
    if (!ev.checked) {
      this.companyInfo.market_type.sale = false;
      this.companyInfo.market_type.rent = false;
    }
  }

  navigatoBack() {
    this.router.navigate(['lista-de-empresas']);
  }

  save() {
    const validateLeads = (lead) => {
      for (const element of lead) {
        if (element.destinataries.length === 0) {
          return this.errorModalUnattendedLeads;
        }
        if (!element.time_alert_value) {
          return this.errorModalUnattendedAlertTime;
        }
      }
      return null;
    };

    const errorModal = validateLeads(this.companyInfo.unattended_lead_alert);

    if (errorModal) {
      this.btnsService.show(errorModal);
      return;
    }

    if (this.companyInfo.market_type.primary_market === false && this.companyInfo.market_type.secondary_market === false) {
      this.btnsService.show(this.errorModalBtns);
      return;
    }

    if (this.companyInfo.market_type.secondary_market === true) { // Validate Market
      if (this.companyInfo.market_type.sale === false && this.companyInfo.market_type.rent === false) {
        this.btnsService.show(this.errorModalMarket);
        return;
      }
    }

    let formatedCompany = JSON.parse(JSON.stringify(this.companyInfo)); // Deep copying

    formatedCompany.unattended_lead_alert.forEach(element => {
      element.time_type = this.formatAlertTime(element.time_type);
    });

    this.companyService.updateCompanyConfig(formatedCompany).subscribe(resp => {
      this.snackbarService.show('As alterações foram salvas.', 'success');
    }, err => {

      if (err.error.messages[0]) {
        this.btnsService.show({
          title: 'Atenção',
          description: err.error.messages[0].message,
          buttons: [{
            btnType: 0,
            title: 'Ok',
            func: () => null,
          }]
        });
      }

    });
  }
}
